'use client'

import React from 'react'

type Props = {
    length: number
    width: number
}

const WIDTH = 340
const HEIGHT = 220

export default function RectangleChart({ length, width }: Props) {
    const maxDim = Math.max(length, width, 0.0001)
    const scale = 160 / maxDim
    const l = Math.max(length * scale, 20)
    const w = Math.max(width * scale, 20)

    const x = (WIDTH - l) / 2
    const y = (HEIGHT - w) / 2

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <rect x={x} y={y} width={l} height={w} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <text x={x + l / 2} y={y + w + 20} fontSize={12} textAnchor="middle" fill="#374151">l = {length.toFixed(2)}</text>
            <text x={x - 10} y={y + w / 2} fontSize={12} textAnchor="end" fill="#374151">w = {width.toFixed(2)}</text>
        </svg>
    )
}
